<div class="skeleton" *ngIf="!interaction">
  <div class="header-wrap content-wrap-inner compact">
    <ion-skeleton-text animated class="skeleton-line" style="width: 30%; height: 1.5rem;"></ion-skeleton-text>
  </div>
  <div class="list-wrap">
    <div class="list">
      <div class="line line-empty content-wrap-inner compact"></div>
      <div class="line line-small content-wrap-inner compact" style="display: flex; flex-direction: row; gap: 3rem; margin-bottom: 3rem;">
        <div style="display: flex; flex-direction: row; gap: 3rem; width: 100%; align-items: center;">
          <ion-skeleton-text animated class="skeleton-circle"></ion-skeleton-text>
          <ion-skeleton-text animated class="skeleton-line" style="width: 40%;"></ion-skeleton-text>
        </div>
        <ion-skeleton-text animated class="skeleton-circle"></ion-skeleton-text>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="interaction">
  <div class="header-wrap content-wrap-inner compact">
    <h3 class="interaction-title">Interaction: <span class="my-color-blue">{{ interaction.name }}</span></h3>
  </div>
  <ng-container *ngIf="!!interaction.interactionsGroups && interaction.interactionsGroups.length > 0">
    <ng-container *ngFor="let group of interaction.interactionsGroups">
      <div class="header-wrap content-wrap-inner compact">
        <h4>Group: <span class="my-color-blue">{{ group.name }}</span></h4>
      </div>
      <div class="list-wrap">
        <div class="list">
          <div class="line line-empty content-wrap-inner compact"></div>
          <ng-container *ngIf="!!group.interactionsCards && group.interactionsCards.length > 0">
            <ng-container *ngFor="let card of group.interactionsCards">
              <div class="line line-small content-wrap-inner compact">
                <app-journey-list-template-interaction-card
                  [title]="card.title"
                  [type]="card.type"
                  [completed]="card.cardAnswer ? card.cardAnswer.isCompleted : false"
                  [passed]="card.cardAnswer ? card.cardAnswer.isPassed : false"
                ></app-journey-list-template-interaction-card>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
